import { defineStore } from 'pinia';
import { useAxios } from '@/axios';
import type { AxiosResponse } from 'axios';
import { Base64 } from 'js-base64';
import { i18n } from '@/main';

export const useGlobalComponentsStore = defineStore('globalComponentsStore', {
    state: () => {
        return {
            showSnackbar: false as boolean,
            text: '' as string,
            class: '' as string,
            timeout: 0 as number,
            showLoading: false as boolean,
            menuModule: 'all' as string,
            showDialog: false as boolean,
            showConfirmDialog: false as boolean,
            confirmDialogState: {
                item: {} as any,
                item_id: 0 as number,
                title: i18n.global.t('ConfirmDialog.title-confirmation') as string | null,
                showCloseBtn: true as boolean | null,
                action: null as string | null,
                callbackAction: null as any,
                text: null as string | null,
                confirmBtnText: i18n.global.t('ConfirmDialog.confirm-delete') as string | null,
                icon: 'mdi-delete' as string | null,
                class: 'danger' as string | null,
                endpoint: null as string | null,
                component: null as string | null,
                name: null as string | null, //TOTO SE POUZIVA CISTE K VRACENI DAT, NIKOLIV K ZOBRAZENI V KOMPONENTE
                return: ['item_id'] as Array<string>,
            },
            onConfirmCallback: null as Function | null,
            showFilterDialog: false as boolean,
            filters: {
                stockItemsArchive: Base64.encode(JSON.stringify([{ f: 'archived_at', o: 'neq', v: null }])) as
                    | string
                    | null,
                stockItemRegistrationNumberSeries: null as string | null,
                stockItemStocktakingRegistrationNumberSeries: null as string | null,
            } as any,
        };
    },
    persist: {
        paths: ['menuModule', 'filters'],
    },
    getters: {
        /*getMenuModule: (state) : string => state.menuModule,*/
        getShowDialog: (state): boolean => state.showDialog,
        getShowConfirmDialog: (state): boolean => state.showConfirmDialog,
        getOnConfirmCallback: (state): Function | null => state.onConfirmCallback,
        getConfirmDialogState: (state): any => state.confirmDialogState,
        getShowFilterDialog: (state): boolean => state.showFilterDialog,
        getFilters: (state): boolean => state.filters,
    },
    actions: {
        async makeApiCalls(apiCalls: any, getResponse: boolean): Promise<AxiosResponse[] | void> {
            const promises = apiCalls.map((call: any) => {
                const { method, endpoint, data, whereToStore, whatStore, convertObjectToArray } = call;
                return useAxios()
                    .request({
                        method,
                        url: endpoint,
                        data,
                    })
                    .then((response: AxiosResponse) => {
                        //get, delete?
                        if (!getResponse) {
                            if (convertObjectToArray) {
                                (this as any)[whereToStore] = whatStore
                                    ? Object.keys(response.data[whatStore]).map((key) => response.data[whatStore][key])
                                    : response.data;
                            } else {
                                (this as any)[whereToStore] = whatStore ? response.data[whatStore] : response.data;
                            }
                        }
                        //post, put, patch
                        else {
                            return response;
                        }
                    })
                    .catch((error: any) => {
                        throw error;
                    });
            });

            const responses = await Promise.all(promises);
            if (getResponse) return responses;
        },
        async doApiCall(data: any, getResponse: boolean, returnProperty: string | null): Promise<any> {
            const response = await this.makeApiCalls(data, true);
            if (getResponse && response && response.length > 0) {
                if (returnProperty) return response[0].data[returnProperty];
                else return response[0].data;
            }
        },
        toggleShowSnackbar(): void {
            this.computeNotificationTimeout();
            this.showSnackbar = true;
        },
        hideSnackbar(): void {
            this.showSnackbar = false;
        },
        toggleShowLoading(): void {
            this.showLoading = !this.showLoading;
        },
        setShowLoading(value: boolean): void {
            this.showLoading = value;
        },
        toggleShowDialog(): void {
            this.showDialog = !this.showDialog;
        },
        hideDialog(): void {
            this.showDialog = false;
        },
        visibleDialog(): void {
            this.showDialog = true;
        },
        toggleShowConfirmDialog(): void {
            this.showConfirmDialog = !this.showConfirmDialog;
        },
        toggleShowFilterDialog(): void {
            this.showFilterDialog = !this.showFilterDialog;
        },
        computeNotificationTimeout(): void {
            const words = this.text.trim().split(/\s+/).length;
            const speed = 200;
            const timeInMinutes = words / speed;
            const timeInMilliseconds = timeInMinutes * 60 * 1000;
            this.timeout = Math.max(Math.round(timeInMilliseconds), 3000);
        },
        setSnackbarTextAndClass(msg: string, className: string): void {
            //dostal jsem stejny error tim padem nezafunguje watch, ale musim zobrazit chybu
            if (this.text === msg) this.toggleShowSnackbar();

            this.text = msg;
            this.class = className;
        },
        setMenuModule(module: string): void {
            this.menuModule = module;
        },
        setFilters(module: string, filterString: string | null) {
            this.filters[module] = filterString;
        },
        setConfirmDialogState(data: any): void {
            this.confirmDialogState = data;
        },
        setOnConfirmCallback(callback: Function | null): void {
            this.onConfirmCallback = callback;
        },
    },
});
